import { withActionDialogLock } from "@/action-dialog/actionDialogLock";
import { FileRecordVersionHistoryCallable } from "@/action-dialog/callables";
import type { FileRecord } from "@cohesive/api-client";

export interface FileRecordVersionHistoryParams {
  record: FileRecord;
}

export function runFileRecordVersionHistoryWorkflow(
  params: FileRecordVersionHistoryParams,
): Promise<void> {
  return withActionDialogLock(() =>
    FileRecordVersionHistoryCallable.call({ record: params.record }),
  );
}
